import * as React from 'react'
import cx from 'classnames'
import styles from './Action.sass'
import Tooltip from 'components/Tooltip'

interface ActionProps {
  children?: React.ReactNode
  disabled?: boolean
  active?: boolean
  danger?: boolean
  primary?: boolean
  onClick?: () => unknown
  tooltip?: string
  dataTest?: string
}

/**
 * The Action
 */
export default function Action({
  children,
  disabled,
  onClick,
  active,
  danger,
  primary,
  tooltip,
  dataTest,
}: ActionProps) {
  const click = React.useCallback(
    (e: React.MouseEvent) => {
      e.preventDefault()
      if (!disabled) {
        onClick?.()
      }
    },
    [onClick, disabled]
  )

  const action = (
    <a
      onClick={click}
      className={cx(
        styles.root,
        active && styles.active,
        danger && styles.danger,
        primary && styles.primary
      )}
      data-test={dataTest}
    >
      {children}
    </a>
  )

  return (
    <>
      {tooltip ? (
        <Tooltip placement="top" content={tooltip}>
          {action}
        </Tooltip>
      ) : (
        action
      )}
    </>
  )
}
